// The achievements' words the web owns (spec web/achievements): each tier's name and each stage's
// heading, as the catalog's spec groups them (journey/achievements.md, 3.1 and 3.6), and each tier's
// glyph. The names, roasts and glyphs of the achievements themselves are the catalog's, read from
// the board.
import type { AchievementView, Stage, Tier } from "../../api/generated/model";
import type { BadgeState } from "./Badge";

export const TIER_NAME: Record<Tier, string> = {
  extra: "Extra",
  "supporting-role": "Supporting Role",
  "leading-role": "Leading Role",
  "directors-cut": "Director's Cut",
  "cult-classic": "Cult Classic",
};

export const STAGE_NAME: Record<Stage, string> = {
  account: "Sign-up, sign-in and account",
  team: "Team and invitations",
  brands: "Brands, products and folders",
  library: "Uploads and the library",
  generations: "Generations",
  templates: "Templates",
  editor: "The editor and exports",
  saving: "Saving",
  sounds: "Sounds and voices",
  actors: "AI actors",
  credits: "Credits",
  across: "Across the app",
};

/** A tier's own glyph, for a badge that stands for the tier (a summary's chip, a member's best). */
export const TIER_GLYPH: Record<Tier, string> = {
  extra: "🎟️",
  "supporting-role": "🎞️",
  "leading-role": "🌟",
  "directors-cut": "🎬",
  "cult-classic": "📼",
};

/** The tier's colour (`--cai-tier-*`): its name, a card's ring and its kicker. */
export const tierColor = (tier: Tier) => `var(--cai-tier-${tier})`;

/** The badge for an achievement on the board: `fresh` when it is a new unlock, shown once. */
export function badgeState(view: AchievementView, fresh: boolean): BadgeState {
  if (view.earned_in.length > 0) return fresh ? "new" : "earned";
  return view.secret ? "secret" : "locked";
}

/** "2 Oct", with its year when it is not this one. */
export function earnedOn(at: string): string {
  const day = new Date(at);
  const year = day.getFullYear() === new Date().getFullYear() ? undefined : "numeric";
  return day.toLocaleDateString("en-GB", { day: "numeric", month: "short", year });
}
